import serverOptimized from '@nykaa/utils/serverOptimized';

export default serverOptimized(
  () => import(/* webpackChunkName: "shoppingBag.m" */ './Loadable'),
  ''
);
